import axios from "axios";
import { adaptPostPutTask } from "../../TransactionDetailsPage/Main/Tasks/api/apiAdapters";

export const parseTaskFormErrors = (err) => {
  const genericError = "Uh-oh! Something went wrong.";
  if (!/text|json/.test(err.response?.headers?.["content-type"] || "")) {
    return [genericError];
  }

  const parsedError = String(err.response?.data || "").split(" - ")[1];
  if (parsedError?.startsWith("[")) {
    return JSON.parse(parsedError);
  }

  return [parsedError || err.message || genericError];
};

export const createTaskRequest = async ({ taskData, listingUuid, v4TaskApi }) => {
  const apiPath = v4TaskApi ? "/api/v4/transactions/tasks" : "/tasks";
  const data = {
    task: { ...taskData, completed: taskData.completed ? "true" : taskData.completed },
    authenticity_token: ReactOnRails.authenticityToken(),
  };

  if (listingUuid) {
    data.uuid = listingUuid;
  }

  const { data: responseData } = await axios.post(apiPath, data);
  return responseData;
};

export const updateTaskRequest = async ({
  taskData,
  listingUuid,
  v4TaskApi,
}) => {
  const apiPath = v4TaskApi ? `/api/v4/transactions/tasks/${listingUuid}` : `/tasks/${taskData.id}`;
  const data = {
    task: {
      ...taskData,
      completed: taskData.completed ? "true" : taskData.completed,
      run: !taskData.completed,
    },
    authenticity_token: ReactOnRails.authenticityToken(),
  };

  if (listingUuid) {
    data.task.uuid = listingUuid;
  }
  if (v4TaskApi) {
    data.task = adaptPostPutTask(data.task);
  }

  const { data: responseData } = await axios.patch(apiPath, data);
  return responseData;
};
